// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Zp-z","giftOrPromoSelector":"_p-z","disabled":"aq-z","subTitle":"bq-z","selectShipAddressMessage":"cq-z","changePayment":"dq-z"};